module.exports = __webpack_public_path__ + "static/media/400243_02.ff482e56.png";